import { apiService } from './api.service';

interface SupportedLanguages {
  [key: string]: string;
}

class TranslationService {
  private supportedLanguages: SupportedLanguages = {};
  private currentLanguage: string = 'en';

  async initialize() {
    try {
      const response: any = await apiService.getSupportedLanguages();
      this.supportedLanguages = response.languages;
    } catch (error) {
      console.error('Failed to load supported languages:', error);
      // Fallback languages
      this.supportedLanguages = {
        en: 'English',
        es: 'Spanish',
        fr: 'French',
        de: 'German',
        hi: 'Hindi',
        zh: 'Chinese',
        ja: 'Japanese',
        ar: 'Arabic',
        pt: 'Portuguese',
        ru: 'Russian'
      };
    }
  }

  async translate(text: string, targetLang: string, sourceLang?: string): Promise<string> {
    try {
      const response: any = await apiService.translate(text, targetLang, sourceLang);
      return response.translation;
    } catch (error) {
      console.error('Translation failed:', error);
      return text; // Return original text if translation fails
    }
  }

  setCurrentLanguage(lang: string) {
    if (this.supportedLanguages[lang]) {
      this.currentLanguage = lang;
      localStorage.setItem('aix-sync-language', lang);
    }
  }

  getCurrentLanguage(): string {
    const saved = localStorage.getItem('aix-sync-language');
    return saved || this.currentLanguage;
  }

  getSupportedLanguages(): SupportedLanguages {
    return this.supportedLanguages;
  }

  getLanguageName(code: string): string {
    return this.supportedLanguages[code] || code;
  }
}

export const translationService = new TranslationService();
